import gql from "graphql-tag";

export const QueryGetAds = gql(`
query($id: ID!) {
    getAds(id: $id) {
        id
        title
        image
        link
        target
        position
        start_time
        end_time
        size
        description
        type
        status
        created
        updated
    }
}`);

export const QueryGetListAds = gql(`
query {
    listAds {
        items {
            id
            title
        	image
        	link
        	target
        	position
        	start_time
        	end_time
            size
            description
            type
        	status
            created
            updated
        }
    }
}`);

export const MutationCreateAds = gql(`
mutation(
    $id: ID!
    $title: String!
    $image: String!
    $link: String
    $target: String
    $position: String
    $start_time: String
    $end_time: String
    $size: String
    $description: String
    $type: String
    $status: STATUS
    $created: String
    $updated: String
) {
    createAds(input: {
        id: $id
        title: $title
        image: $image
        link: $link
        target: $target
        position: $position
        start_time: $start_time
        end_time: $end_time
        size: $size
        description: $description
        type: $type
        status: $status
        created: $created
        updated: $updated
    }) {
        id
        title
        image
        link
        target
        position
        start_time
        end_time
        size
        description
        type
        status
        created
        updated
    }
}`);

export const MutationUpdateAds = gql(`
mutation(
    $id: ID!
    $title: String
    $image: String
    $link: String
    $target: String
    $position: String
    $start_time: String
    $end_time: String
    $size: String
    $description: String
    $type: String
    $status: STATUS
    $created: String
    $updated: String
) {
    updateAds(input: {
        id: $id
        title: $title
        image: $image
        link: $link
        target: $target
        position: $position
        start_time: $start_time
        end_time: $end_time
        size: $size
        description: $description
        type: $type
        status: $status
        created: $created
        updated: $updated
    }) {
        id
        title
        image
        link
        target
        position
        start_time
        end_time
        size
        description
        type
        status
        created
        updated
    }
}`);

export const MutationDeleteAds = gql(`
mutation(
    $id: ID!
) {
    deleteAds(input: {id: $id}) {
        __typename
    }
}`);
